module.exports = __webpack_public_path__ + "static/media/ge_mx_id.287a6817.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/biznisnet2020/resources/ge_mx_id.png
// module id = 461
// module chunks = 0